import { EnvironmentInjector, createEnvironmentInjector } from '@angular/core';

import { LazyComponentDetails } from '@core/shared/util';
import { provideCostCenterArticleRangesForCostCenterDataAccess } from '@mp/document-management/cost-center-article-ranges/cost-centers/data-access';
import { ComponentPluginComponent } from '@mp/shared/component-plugins/util';
import type { CostCenterDetailsTabPlugin, CostCenterDetailsTabPluginInput } from '@mpomd/shared/util';

export function createCostCenterArticleRangesTabPlugin(): CostCenterDetailsTabPlugin {
  return {
    label: 'Fachbereichssortimente',
    async getComponentDetails(
      parentInjector: EnvironmentInjector,
    ): Promise<LazyComponentDetails<ComponentPluginComponent<CostCenterDetailsTabPluginInput>>> {
      const { CostCenterArticleRangesTabComponent } = await import('../components');

      return {
        component: CostCenterArticleRangesTabComponent,
        environmentInjector: createEnvironmentInjector(
          provideCostCenterArticleRangesForCostCenterDataAccess(),
          parentInjector,
        ),
      };
    },
  };
}
